import { useEffect, useState } from "react";
import { useCookies } from "react-cookie";
import Modal from '../../components/commons/Modal';
import CookiesManagerContent from "./components/CookiesManagerContent";
import { useGoogleAnalytics } from "../../../utils/useGoogleAnalytics";

interface CookiesManagerProps {
  isReady: boolean;
  isLoading: boolean;
}

export default function CookiesManager({ isReady, isLoading }: CookiesManagerProps) {
  const [showCookieConsent, setShowCookieConsent] = useState(false);
  const [cookies, setCookie, removeCookie] = useCookies(['cookieConsent']);
  const { clearGACookies } = useGoogleAnalytics();

  useEffect(() => {
    if (isReady && !isLoading) {
      try {
        const bannerShown = localStorage.getItem('cookieBannerShown');
        const cookieDecision = localStorage.getItem('cookieDecision');
        if (bannerShown !== 'true' || (cookieDecision === 'accepted' && !cookies.cookieConsent)) {
          setShowCookieConsent(true);
        }
      } catch (error) {
        setShowCookieConsent(true);
      }
    }
  }, [isReady, isLoading, cookies.cookieConsent]);

  if (!isReady || isLoading || !showCookieConsent) {
    return null;
  }

  const handleAcceptCookies = () => {
    try {
      // setCookie('cookieConsent', 'true', { path: '/', maxAge: 60 * 60 * 24 * 365 }); // un año
      setCookie('cookieConsent', 'true', { path: '/', maxAge: 60 * 60 * 24 * 365 * 100 }); // 100 años
      localStorage.setItem('cookieDecision', 'accepted');
    } catch (error) {
      console.error('Error al aceptar cookies:', error);
    }
  };

  const handleDeclineCookies = () => {
    try {
      removeCookie('cookieConsent', { path: '/' });
      clearGACookies();
      localStorage.setItem('cookieDecision', 'declined');
    } catch (error) {
      console.error('Error al rechazar cookies:', error);
    }
  };


  return (
    <>
      <div 
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          zIndex: 9998,
          cursor: 'not-allowed',
        }}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
        }}
      />
      
      <div style={{ position: 'relative', zIndex: 9999 }}>
        <Modal
          showClose={false}
          open={true}
          child={
            <CookiesManagerContent
              setOpened={() => setShowCookieConsent(false)}
              onAccept={() => {
                try {
                  // Marcar que se ha mostrado el banner
                  localStorage.setItem('cookieBannerShown', 'true');
                  // Aceptar cookies
                  handleAcceptCookies();
                  setShowCookieConsent(false);
                } catch (error) {
                  console.error('Error al aceptar cookies desde el banner:', error);
                }
              }}
              onDecline={() => {
                try {
                  localStorage.setItem('cookieBannerShown', 'true');
                  handleDeclineCookies();
                  setShowCookieConsent(false);
                } catch (error) {
                  console.error('Error al rechazar cookies desde el banner:', error);
                }
              }}
            />
          }
        />
      </div>
    </>
  );
}
